/** Threshold ab dem der Scroll-Top angezeigt wird */
export const THRESHOLD = 700 as const;
